//封装基本路径并抛出
// export const baseURL = "http://192.168.1.124:8089/";
// export const baseURL = "http://192.168.1.114:8089/";
// export const baseURL = "http://192.168.1.91:8089/";
// export const baseURL = "http://www.airlib.com:8123/";
export const baseURL = "https://xytvadmin.hlrmt.com";      //正式地址
// export const baseURL = "http://192.168.1.241:8111/";//尹
// export const baseURL = "http://192.168.1.99:8111/";//测试d





// WEBPACK FOOTER //
// ./src/utils/config.js